<template>
  <div class="members-notifications-table">
    <div class="d-flex justify-content-between flex-column flex-sm-row">
      <div>
        <h4>Individual settings for provisioned accounts</h4>
        <p class="text-muted">
          Choose which members with provisioned accounts should be allowed to receive emails from Hubstaff
        </p>
      </div>
      <div>
        <AppInputSearch
          :show-reset-button="!!searchTerm"
          @reset="resetSearch"
        >
          <AppInput
            v-model="searchTerm"
            type="search"
            placeholder="Search members"
          />
        </AppInputSearch>
      </div>
    </div>
    <AppScrollableTable
      :has-fixed-column="false"
      class="mt-10"
    >
      <AppTable
        ref="table"
        hoverable
        :loading="showLoading"
        :table-data="members"
      >
        <template #empty>
          <div class="mt-20 text-center">
            <img
              :src="IMAGE_EMPTY_BOX"
              class="mb-16"
              alt="Empty Box"
            >
            <h4 class="">No members to choose from</h4>
            <p class="text-muted">
              Please visit the Members page to add new members
            </p>
          </div>
        </template>
        <AppTableColumn
          v-slot="{ row }"
          header="Name"
        >
          <div class="d-flex align-items-center">
            <PopoverAvatar
              :user-id="row.user_id"
              :organization-id="organizationId"
            >
              <HubAvatar
                :user-id="row.user_id"
                :users-avatars="usersAvatars"
              />
            </PopoverAvatar>
            <div
              :key="row.id"
              v-tooltip="{ html: true }"
              :title="row.email"
              class="member-name"
            >
              {{ row.name }}
            </div>
          </div>
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Role"
        >
          {{ row.role_name }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Receive email?"
        >
          <AppOnOffToggle
            :value="row.allow_receiving_emails"
            @input="onChangeNotificationSetting(row.user_id, !row.allow_receiving_emails)"
          />
        </AppTableColumn>
      </AppTable>
    </AppScrollableTable>
  </div>
</template>

<script>
import { mapInertiaProps } from '@/utils/inertia';
import PopoverAvatar from '~/components/PopoverAvatar.vue';
import { createUsersAvatarsMixin } from '~/mixins/UsersAvatarsMixin';
import { IMAGE_EMPTY_BOX } from '~/rails_assets';

export default {
  name: 'MemberProfileFieldsTable',
  components: {
    PopoverAvatar,
  },
  mixins: [createUsersAvatarsMixin('memberAvatars')],
  props: {
    members: {
      type: Array,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
    showLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showConfirmArchiveDialog: false,
      activePolicy: null,
      IMAGE_EMPTY_BOX,
    };
  },
  computed: {
    ...mapInertiaProps({
      organization: 'organization',
    }),
    memberAvatars() {
      return this.members.map((member) => ({ id: member.user_id, avatar: member.avatar_url }));
    },
    searchTerm: {
      get() {
        return this.search;
      },
      set(searchTerm) {
        this.$emit('search-updated', searchTerm);
      },
    },
  },
  methods: {
    settingValue(member) {
      return member.allow_receiving_emails;
    },
    resetSearch() {
      this.$emit('search-updated', '');
    },
    onChangeNotificationSetting(userId, settingValue) {
      this.$emit('update-member', userId, settingValue);
    },
  },
};
</script>
